const initialState = {
    client: null,
    prestataire: null,
    donneurOrdre: null
};

export default function profilReducer(state = initialState, action) {
    switch (action.type) {

        case "UPDATE_PROFIL_CLIENT":
            return {
                ...state,
                client: {
                    ...state.client,
                    ...action.payload
                }
            };

        case "UPDATE_PROFIL_PRESTATAIRE":
            return {
                ...state,
                prestataire: {
                    ...state.prestataire,
                    ...action.payload
                }
            };

        case "UPDATE_PROFIL_DONNEUR_ORDRE":
            return {
                ...state,
                donneurOrdre: {
                    ...state.donneurOrdre,
                    ...action.payload
                }
            };

        case "SET_PROFIL_CLIENT":
            return { ...state, client: action.payload };

        case "SET_PROFIL_PRESTATAIRE":
            return { ...state, prestataire: action.payload };
        
        case "SET_PROFIL_DONNEUR_ORDRE":
            return { ...state, donneurOrdre: action.payload };

        default:
            return state;
    }
}
